import moment from 'moment';

class Overdue {
  constructor() {
    this.instance = null;
  }

  init(instance) {
    this.instance = instance;
    this.instance.addTaskLayer({
      renderer: {
        render: task => this.rendererOverdueTask(task),
        getVisibleRange: instance.getVisibleTasksRange,
      },
    });
  }

  checkIsOverdue(task) {
    return moment(task.end_date).isBefore() && task.progress < 1 && task.$level !== 0 && task.type === 'task';
  }

  rendererOverdueTask(task) {
    if (this.checkIsOverdue(task) && this.instance.config.highlight_overdue) {
      const el = document.createElement('div');

      el.className = 'highlightOverdue';
      const sizes = this.instance.getTaskPosition(task);

      el.style.top = `${sizes.top}px`;
      el.style.width = `${100}%`;
      el.style.height = `${this.instance.config.row_height}px`;

      return el;
    }
  }
}

export default new Overdue();
